import { Skeleton } from '@/components/ui/skeleton'
import { ListMembersAvatars } from '@/modules/chatting/ui/chat-window/lists/members-avatars'

export const ListItemSkeleton = () => {
  return (
    <div className="flex items-center justify-between gap-6 px-3 py-2">
      <div className="space-y-3.5">
        <Skeleton className="h-3 w-[110px] dark:bg-skeleton" />
        <Skeleton className="h-3 w-[200px] dark:bg-skeleton" />
      </div>
      <ListMembersAvatars
        size={50}
        isLoading
      />
    </div>
  )
}
